import React, { PropsWithChildren, useContext, useMemo, useState } from 'react';
import { useLoadedData } from '../../../hooks/useLoadedData';
import { apiFetch } from '../../../api/core';

interface BlocksConfiguration {
  fields: string[];
}

interface TableBlocksConfiguration {
  fields: string[];
  list_fields?: string;
}

interface KnownCMSSettings {
  custom_fields_block_settings?: Record<string, BlocksConfiguration>;
  configurable_table_block_settings?: Record<string, TableBlocksConfiguration>;
}

type SettingsT = Partial<KnownCMSSettings> & Record<string, any>;

interface ICMSSettingsContext {
  ensureLoaded: () => void;
  reload: () => void;
  settings: SettingsT;
  updateSettings: (c: Partial<SettingsT>) => void;
}

const CMSSettingsContext = React.createContext<ICMSSettingsContext>({
  ensureLoaded: () => {},
  reload: () => {},
  settings: {},
  updateSettings: () => {},
});

export const useCMSSettingsContext = () => useContext(CMSSettingsContext);


export const getEntityAttributesFormSettingsKey = (recordType: string) => `attributes_form_${recordType}`;


interface ProviderProps {
  apiPath: string;
}

const useCMSSettingsContextData = (props: ProviderProps) => {
  const [doLoad, setDoLoad] = useState<boolean>(false);
  const data = useLoadedData<SettingsT>(`${props.apiPath}/manage/settings`, {}, doLoad && !!props.apiPath);

  const ctx: ICMSSettingsContext = useMemo(() => {
    return {
      ensureLoaded: () => setDoLoad(true),
      reload: () => data.reload(),
      settings: data.data,
      updateSettings: (c) => apiFetch<SettingsT>(`${props.apiPath}/manage/settings`, "put", c)
        .then(x => data.setData(x)),
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.data]);

  return ctx;
}

export const CMSSettingsContextProvider = (props: PropsWithChildren<ProviderProps>) => {
  const data = useCMSSettingsContextData(props);
  return (
    <CMSSettingsContext.Provider value={data}>
      {props.children}
    </CMSSettingsContext.Provider>
  );
}
